import { SnColorPalette } from '@lib/common/types';

export interface IConfirmDialogButtonConfig {
  text: string;
  color?: SnColorPalette;
  value?: string;
}

export interface IConfirmationInputConfig {
  text: string;
  label?: string;
  placeholder?: string;
}

export interface IConfirmDialogConfig {
  title?: string;
  message: string;
  confirmButton?: string | IConfirmDialogButtonConfig;
  alternativeButton?: string | IConfirmDialogButtonConfig;
  cancelButton?: string | IConfirmDialogButtonConfig;
  actionOnClose?: boolean;
  // Enhanced confirmation options
  typeDeleteToConfirm?: boolean; // For backward compatibility
  confirmationInput?: IConfirmationInputConfig; // New dynamic option
}
